import { useState } from "react";

const NumericUpDown = ({ value, onChange, min = 1, max = 100 }) => {
  const [currentValue, setCurrentValue] = useState(value);

  const handleIncrement = () => {
    const newValue = currentValue + 1;
    if (newValue <= max) {
      setCurrentValue(newValue);
      onChange(newValue);
    }
  };

  const handleDecrement = () => {
    const newValue = currentValue - 1;
    if (newValue >= min) {
      setCurrentValue(newValue);
      onChange(newValue);
    }
  };

  return (
    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
      <button
        className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700"
        onClick={handleDecrement}
      >
        -
      </button>
      <span className="px-4 py-1 bg-white text-gray-700">{currentValue}</span>
      <button
        className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700"
        onClick={handleIncrement}
      >
        +
      </button>
    </div>
  );
};

export default NumericUpDown;